export const actions = {
    GET_COURSE_PAGE_DATA: 'GET_COURSE_PAGE_DATA',
    SET_COURSE_PAGE_DATA: 'SET_COURSE_PAGE_DATA',
    GET_COURSE_PAGE_HEADERINFORMATOIN_DATA: 'GET_COURSE_PAGE_HEADERINFORMATOIN_DATA',
    SET_COURSE_PAGE_HEADERINFORMATOIN_DATA: 'SET_COURSE_PAGE_HEADERINFORMATOIN_DATA',
    GET_COURSE_CLASS_ACTIVITY_PROGRESS_DATA: 'GET_COURSE_CLASS_ACTIVITY_PROGRESS_DATA',
    SET_COURSE_CLASS_ACTIVITY_PROGRESS_DATA: 'SET_COURSE_CLASS_ACTIVITY_PROGRESS_DATA',
    GET_COURSE_CLASS_ACTIVITY_REPORT: 'GET_COURSE_CLASS_ACTIVITY_REPORT',
    SET_COURSE_CLASS_ACTIVITY_REPORT: 'SET_COURSE_CLASS_ACTIVITY_REPORT',
    GET_COURSE_CLASS_ACTIVITY_REPORT_DOWNLOAD: 'GET_COURSE_CLASS_ACTIVITY_REPORT_DOWNLOAD',
    SET_COURSE_CLASS_ACTIVITY_REPORT_DOWNLOAD: 'SET_COURSE_CLASS_ACTIVITY_REPORT_DOWNLOAD',
    GET_COURSE_PAGE_CHANGE_CLASS: 'GET_COURSE_PAGE_CHANGE_CLASS',
    SET_COURSE_PAGE_CHANGE_CLASS: 'SET_COURSE_PAGE_CHANGE_CLASS',
    GET_COURSE_HOME_PAGE_SELECTED_TAB: 'GET_COURSE_HOME_PAGE_SELECTED_TAB',
    SET_COURSE_HOME_PAGE_SELECTED_TAB: 'SET_COURSE_HOME_PAGE_SELECTED_TAB',
    GET_COURSE_PAGE_INCOMING_ACTIVITY: 'GET_COURSE_PAGE_INCOMING_ACTIVITY',
    SET_COURSE_PAGE_INCOMING_ACTIVITY: 'SET_COURSE_PAGE_INCOMING_ACTIVITY',
    GET_COURSE_PAGE_ANNOUNCEMENTS: 'GET_COURSE_PAGE_ANNOUNCEMENTS',
    SET_COURSE_PAGE_ANNOUNCEMENTS: 'SET_COURSE_PAGE_ANNOUNCEMENTS',
    GET_COURSE_PAGE_CURRENT_WEEK_ACTIVITIES: 'GET_COURSE_PAGE_CURRENT_WEEK_ACTIVITIES',
    SET_COURSE_PAGE_CURRENT_WEEK_ACTIVITIES: 'SET_COURSE_PAGE_CURRENT_WEEK_ACTIVITIES',
    GET_COURSE_PAGE_COURSECONTENTS_WEEKS: 'GET_COURSE_PAGE_COURSECONTENTS_WEEKS',
    SET_COURSE_PAGE_COURSECONTENTS_WEEKS: 'SET_COURSE_PAGE_COURSECONTENTS_WEEKS',
    GET_COURSE_PAGE_COURSECONTENTS_WEEKS_ACTIVITIES: 'GET_COURSE_PAGE_COURSECONTENTS_WEEKS_ACTIVITIES',
    SET_COURSE_PAGE_COURSECONTENTS_WEEKS_ACTIVITIES: 'SET_COURSE_PAGE_COURSECONTENTS_WEEKS_ACTIVITIES',
    GET_COURSE_PAGE_ACTIVITY_CARDS: 'GET_COURSE_PAGE_ACTIVITY_CARDS',
    SET_COURSE_PAGE_ACTIVITY_CARDS: 'SET_COURSE_PAGE_ACTIVITY_CARDS',
    SET_COURSE_PAGE_DELETE_ACTIVITY: 'SET_COURSE_PAGE_DELETE_ACTIVITY',
    GET_COURSE_PAGE_DELETE_ACTIVITY: 'GET_COURSE_PAGE_DELETE_ACTIVITY',
    GET_SURVEY_CHOICES: 'GET_SURVEY_CHOICES',
    SET_SURVEY_CHOICES: 'SET_SURVEY_CHOICES',
    GET_COURSE_CONTENT_MENU: 'GET_COURSE_CONTENT_MENU',
    SET_COURSE_CONTENT_MENU: 'SET_COURSE_CONTENT_MENU',
    GET_ACTIVITY_IDS_BY_WEEKS : 'GET_ACTIVITY_IDS_BY_WEEKS',
    SET_ACTIVITY_IDS_BY_WEEKS : 'SET_ACTIVITY_IDS_BY_WEEKS',
    GET_COURSE_FILES: 'GET_COURSE_FILES',
    SET_COURSE_FILES: 'SET_COURSE_FILES',
    GET_COURSE_STUDENT_LIST: 'GET_COURSE_STUDENT_LIST',
    SET_COURSE_STUDENT_LIST: 'SET_COURSE_STUDENT_LIST',
    GET_COURSE_ASSIGNMENT_GRADE_INFORMATION: 'GET_COURSE_ASSIGNMENT_GRADE_INFORMATION',
    SET_COURSE_ASSIGNMENT_GRADE_INFORMATION: 'SET_COURSE_ASSIGNMENT_GRADE_INFORMATION',
    GET_COURSE_ASSIGNMENT_STUDENT_LIST: 'GET_COURSE_ASSIGNMENT_STUDENT_LIST',
    SET_COURSE_ASSIGNMENT_STUDENT_LIST: 'SET_COURSE_ASSIGNMENT_STUDENT_LIST',
    GET_COURSE_ASSIGNMENT_SAVE_GRADE: 'GET_COURSE_ASSIGNMENT_SAVE_GRADE',
    SET_COURSE_ASSIGNMENT_SAVE_GRADE: 'SET_COURSE_ASSIGNMENT_SAVE_GRADE',
    GET_COURSE_ASSIGNMENT_DOWNLOAD_ALL: 'GET_COURSE_ASSIGNMENT_DOWNLOAD_ALL',
    SET_COURSE_ASSIGNMENT_DOWNLOAD_ALL: 'SET_COURSE_ASSIGNMENT_DOWNLOAD_ALL',
    GET_COURSE_BULK_GRADE: 'GET_COURSE_BULK_GRADE',

    GET_MY_ACTIVITY_STATS: 'GET_MY_ACTIVITY_STATS',
    SET_MY_ACTIVITY_STATS: 'SET_MY_ACTIVITY_STATS',
   
    SET_ACTIVITY_STATUS: 'SET_ACTIVITY_STATUS',
    SET_COURSE_PAGE_PASSİVE_ACTIVITIES_BUTTON:'SET_COURSE_PAGE_PASSİVE_ACTIVITIES_BUTTON',//
    
    GET_COURSE_CLASSES_DATA: 'GET_COURSE_CLASSES_DATA',
    SET_COURSE_CLASSES_DATA: 'SET_COURSE_CLASSES_DATA',

    SET_SHOW_ADD_ACTIVITY: 'SET_SHOW_ADD_ACTIVITY',
    
    SET_ACTIVITY_ID_AFTER_ADD: 'SET_ACTIVITY_ID_AFTER_ADD',

    SET_UPDATE_INPUT: 'SET_UPDATE_INPUT',
    SET_GETTING_WEEKS: 'SET_GETTING_WEEKS',

    SET_COURSE_PAGE_ACTIVITY_CARD_REFRESH: 'SET_COURSE_PAGE_ACTIVITY_CARD_REFRESH',
    SET_ACTID: 'SET_ACTID',
    SET_COURSE_PAGE_CLASSES: 'SET_COURSE_PAGE_CLASSES',

    GET_PROGRESS_PERCENT: 'GET_PROGRESS_PERCENT',
    SET_PROGRESS_PERCENT: 'SET_PROGRESS_PERCENT',

    SET_ACTIVITY_FILTERS: 'SET_ACTIVITY_FILTERS',

    ACTIVITY_REPORT_DETAIL_GET_ACTION : 'ACTIVITY_REPORT_DETAIL_GET_ACTION',
    ACTIVITY_REPORT_DETAIL_SET_ACTION : 'ACTIVITY_REPORT_DETAIL_SET_ACTION',

    SET_TRIGGER_GET_ACTIVITIES_ACTION : 'SET_TRIGGER_GET_ACTIVITIES_ACTION',

    SET_SORTING_ACTIVITIES_ACTION : 'SET_SORTING_ACTIVITIES_ACTION',

    CLICK_WEEK_ACTIVITIES : 'CLICK_WEEK_ACTIVITIES',

    SET_TRIGGER_COURSE_STAR: 'SET_TRIGGER_COURSE_STAR',
    
    SET_TRIGGER_REMOVE_PREREQUISITE: 'SET_TRIGGER_REMOVE_PREREQUISITE',

    SET_COURSE_DEFAULT_VİEW: 'SET_COURSE_DEFAULT_VİEW',

    SET_IS_CLICKED_WEEK: 'SET_IS_CLICKED_WEEK',

    SET_GET_MORE_ACTIVITIES: 'SET_GET_MORE_ACTIVITIES',

    SET_RESET_SHOW_MORE_COUNT: 'SET_RESET_SHOW_MORE_COUNT'
};
